module.exports = __webpack_public_path__ + "assets/moosend.f51e13dd.svg";